import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DetailsTable from 'components/DetailsTable';
import React from 'react';
import { isNullUndEmpty } from 'utils/general';


const cleanObject = (array) => (
	array.map(obj => Object.fromEntries(
		Object.entries(obj).filter(([_, v]) => !isNullUndEmpty(v))
	))
);


const ValidationDetailsPreviewDialog = ({ onValidationDetailsDialogClose, validationDetails, translate }) => {
	const { errors = [], warnings = [] } = validationDetails;

	const cleanErrors = cleanObject(errors);
	const cleanWarnings = cleanObject(warnings);

	return (
		<Dialog open maxWidth="sm" onClose={onValidationDetailsDialogClose}>
			<DialogTitle>
				{translate("osfc.dialogs.document-templates.validation.title")}
			</DialogTitle>
			<DialogContent>
				{cleanErrors.length ? (
					<DetailsTable 
						entries={cleanErrors} 
						translate={translate}
						entityName="errors"
						dialogName="document-templates.validation"
					/>
				) : null}
				{cleanWarnings.length ? (
					<DetailsTable 
						entries={cleanWarnings} 
						translate={translate}
						entityName="warnings"
						dialogName="document-templates.validation"
					/>
				) : null}
				<Box mt={2}></Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onValidationDetailsDialogClose} color="primary">
					{translate("ra.action.cancel")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export {
	ValidationDetailsPreviewDialog,
};
